import React from 'react';
import { FaTrashAlt, FaCamera } from 'react-icons/fa';
import './styles/ClockIn.css';

const ClockIn = ({ onClose }) => {
  return (
    <div className="clockin-modal-overlay">
      <div className="clockin-box">
        <h2 className="title">Clock In</h2>
        <h3 className="subtitle">Begin Your Job</h3>

        {/* Name */}
        <div className="row">
          <label className="input-label" htmlFor="firstName">
            Name
          </label>
          <div className="input-group">
            <input id="firstName" type="text" placeholder="Enter First Name" />
            <input type="text" placeholder="Enter Last Name" />
          </div>
        </div>

        {/* Date and Time */}
        <div className="row">
          <label className="input-label" htmlFor="date">
            Date and Time
          </label>
          <div className="input-group date-time-group">
            <div className="input-with-icon">
              <input id="date" type="date" />
            </div>
            <div className="input-with-icon time-input">
              <input type="time" />
            </div>
          </div>
        </div>

        {/* Add Before Picture */}
        <div className="row">
          <label className="input-label">Add Before Picture</label>
          <div className="upload-container">
            <label className="upload-box">
              <FaCamera className="upload-icon" />
              <p>Upload file here</p>
              <input type="file" hidden />
            </label>
            <div className="delete-icon-container">
              <FaTrashAlt className="delete-icon" />
            </div>
          </div>
        </div>

        {/* Note */}
        <div className="row">
          <label className="input-label">Note</label>
          <textarea
            placeholder="Type here......"
            className="textarea"
          ></textarea>
        </div>

        {/* Buttons */}
        <button className="btn-primary">Clock In</button>
        <button className="btn-cancel" onClick={onClose}>
          cancel
        </button>
      </div>
    </div>
  );
};

export default ClockIn;
